import Vue from 'vue'
import Vuex from 'vuex'
import two from '../json/two'
import chapter from '../json/chapter'
import hsnUrls from '../json/hsnUrls'
import modalCategories from '../json/modalCategories'
import { api } from '@/api'

import { SET_API_PUBLIC_TOKEN, SET_INITIAL_MODAL_SHOWN } from './mutation-types'

Vue.use(Vuex)

const state = {
  twos: two,
  chapter: chapter,
  apiPublicToken: null,
  initalModalShown: false,
  hsnUrls,
  modalCategories
}

const actions = {
  async getPublicApiToken ({ commit }) {
    commit(SET_API_PUBLIC_TOKEN, await api.getPublicApiToken())
  },
  initialModalShown ({ commit }) {
    commit(SET_INITIAL_MODAL_SHOWN, true)
  }
}

const mutations = {
  [SET_API_PUBLIC_TOKEN] (state, apiToken) {
    state.apiPublicToken = apiToken
  },
  [SET_INITIAL_MODAL_SHOWN] (state, value) {
    state.initalModalShown = value
  }
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  actions,
  mutations
})
